import { LabraToolTipV2 } from '@labrav/react-components'

import type { FailedErrorMessage } from '../../types/flyout'

export const ViewError = ({ errors }: { errors: FailedErrorMessage[] }) => {
  const updatedErrorList = errors?.map(item => {
    const afterPrefix = item?.message?.includes('Private Offer Name :')
      ? item?.message?.split('Private Offer Name :')[1].trim()
      : item?.message
    const result = afterPrefix?.split(/ (.+)/)[1]
    return result || ''
  })
  const tooltipValue =
    updatedErrorList?.length > 1 ? (
      <div>
        <ul>
          {updatedErrorList?.map(item => (
            <li>
              <div dangerouslySetInnerHTML={{ __html: item }}></div>
            </li>
          ))}
        </ul>
      </div>
    ) : (
      ''
    )
  return (
    <LabraToolTipV2 tooltipPlacement="bottom" description={tooltipValue}>
      <span
        dangerouslySetInnerHTML={{
          __html: `${updatedErrorList[0]} ${updatedErrorList?.length > 1 ? updatedErrorList[1].slice(0, 4) : ''}`,
        }}
      ></span>{' '}
      {updatedErrorList?.length > 1 ? '...' : ''}
    </LabraToolTipV2>
  )
}
